import type { SnippetVariant } from "@nodus/ui";

export const decisionExample = (model: string) => ({
  model,
  state: "Checkout has been failing for every customer for the last hour.",
  questions: {
    urgent: { type: "noul", instructions: "Is this request urgent?" },
    team: { type: "choice", instructions: "Which team should handle this?", criteria: { billing: "Payments and refunds", technical: "Outages and errors", sales: "Plans and upgrades" } },
    severity: { type: "score", instructions: "How severe is the impact?", criteria: ["No impact", "Minor", "Major", "Critical"] },
  },
});

export function decisionSnippets(request: unknown, baseURL: string): SnippetVariant[] {
  const json = JSON.stringify(request, null, 2);
  return [{ id: "curl", label: "curl", code: [
    `curl ${baseURL}/systemone \\`,
    '  -H "Authorization: Bearer $NODUS_API_KEY" \\',
    '  -H "Content-Type: application/json" \\',
    `  -d '${json.replaceAll("'", "'\\''")}'`,
  ].join("\n") }];
}
